import './product-overview.scss';
import productOverview from './product-overview.js';

export default productOverview;
